var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.showBorder==true?'noneData':'noneData noneData-border'},[(_vm.isNoPermission == true)?_c('img',{attrs:{"src":require("../../assets/images/jurisdiction.png")}}):_c('i',{staticClass:"iconfont"},[_vm._v("")]),_c('p',[_vm._v(_vm._s(_vm.title || '还没有相关数据'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }